import {
  ActiveStreamingSession,
  getActiveStreamingSession,
  isSessionInFlight,
} from '../../../../services/streamingService';

// Is this editor changing the patient's CURRENT plan in place?
//
// Only that plan can be the one a live session is running, so only that plan takes the live
// save path (confirmation dialog + in-place PATCH). A brand-new plan (no planId) and a duplicate
// of an older plan both become a NEW plan with its own id: there is nothing to PATCH, and
// routing them into the live dialog is what left its confirm button silently doing nothing —
// the clinician could not save a new plan at all while the patient was streaming.
//
// "Current" is the newest plan, the same test the editor already uses to tell an edit from a
// duplicate.
export function isEditingLatestPlan(
  initPlanId: string | null | undefined,
  latestPlanId: string | undefined,
  isTemplateMode: boolean,
): boolean {
  return Boolean(!isTemplateMode && initPlanId && initPlanId === latestPlanId);
}

// May the ordinary save delete the latest plan before assigning the new one?
//
// The ordinary save replaces a latest plan that has no results yet by DELETING it. While the
// patient is streaming, that plan may be the one their session is running and simply has no
// result posted yet (they are on the first exercise) — deleting it 404s the app's next plan
// fetch and terminates the session. So a live session keeps it: the new plan is added beside it
// and the session carries on untouched.
//
// A failed probe answers "streaming". Keeping an unexecuted plan around is harmless; deleting the
// plan under a running session is not.
export async function mayDeleteLatestPlanBeforeAssign(
  patientId: string,
  probe: (
    patientId: string,
  ) => Promise<ActiveStreamingSession | undefined> = getActiveStreamingSession,
): Promise<boolean> {
  try {
    return !isSessionInFlight(await probe(patientId));
  } catch {
    return false;
  }
}
